import React from 'react'
import FulfilmentSkeleton from '../FulfilmentSkeleton'
import * as Styled from './CollectionBox.styles'

import { AlternativeCollectionBox } from '../AlternativeCollectionBox/AlternativeCollectionBox'
import { CollectionMessage } from './CollectionMessage'
import { CollectionTrolleyButton } from './CollectionTrolleyButton'
import { CollectionTitle } from './CollectionTitle'

import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const determineFeatureType = attributes => {
  const {
    globallyOutOfStock,
    endOfLineOutOfStock,
    preorderUnavailable,
    inStoreJewelleryItem,
    digitalDownload,
    twoManDeliveryUnavailable
  } = attributes
  return (
    globallyOutOfStock ||
    endOfLineOutOfStock ||
    preorderUnavailable ||
    inStoreJewelleryItem ||
    digitalDownload ||
    twoManDeliveryUnavailable
  )
}

const generateDeliverableCollectable = (hasFeatureType, deliveryCollectable, deliveryDeliverable) => {
  const collectable = deliveryCollectable && !hasFeatureType
  const deliverable = deliveryDeliverable && !hasFeatureType
  return [collectable, deliverable]
}

const hideFulfilmentHeader = (deliverable, collectable, collectionMessage, deliveryMessage) =>
  (!deliverable && !collectable) ||
  ((collectable ? !!collectionMessage : true) && (deliverable && !collectable ? !!deliveryMessage : true))

const CollectionBox = ({
  props: collectionProps,
  openStoreSelector,
  chooseAlternativeStore,
  addToTrolley,
  updateIsInitialMount,
  alternativeMessagingOnly
}) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const {
    storeLocator: { collectionStore, collectionMessage, collectionIcon, collectionLoading, deliveryMessage },
    productList
  } = collectionProps

  // Revist this to make a polymorphic function that can be used by both Delivery and Collection
  const [collectable, deliverable] = generateDeliverableCollectable(
    determineFeatureType(collectionProps.attributes),
    collectionProps.attributes.collectable,
    collectionProps.attributes.deliverable
  )

  const HIDE_FULFILMENT_HEADER = hideFulfilmentHeader(deliverable, collectable, collectionMessage, deliveryMessage)

  const collectionMessageProps = {
    collectionIcon,
    collectionMessage,
    collectionStore,
    collectionCutoff: collectionProps.storeLocator.collectionCutoff,
    collectionStockCode: collectionProps.storeLocator.collectionStockCode,
    convenienceStore: collectionProps.storeLocator.convenienceStore
  }

  const collectionTrolleyButtonProps = {
    addToTrolley,
    collectionIcon,
    trolleyButtonOnErrorTracking: collectionProps.trolleyButtonOnErrorTracking,
    collectionStore,
    trolleyButtonTracking: collectionProps.trolleyButtonTracking,
    openStoreSelector,
    partNumber: collectionProps.attributes.partNumber,
    productList
  }

  const alternativeCollectionBoxProps = {
    collectionProps,
    updateIsInitialMount,
    chooseAlternativeStore
  }

  if (alternativeMessagingOnly) {
    return (
      <>
        <CollectionMessage {...collectionMessageProps} isV2 />
        <AlternativeCollectionBox {...alternativeCollectionBoxProps} isV2 />
      </>
    )
  }

  return (
    HIDE_FULFILMENT_HEADER &&
    collectable && (
      <Styled.FulfilmentCollectionContainer data-test='fulfilment-collection-box' PDP_V2_FLAG={PDP_V2_FLAG}>
        {collectionLoading && <FulfilmentSkeleton />}
        {!collectionLoading && collectionMessage && (
          <Styled.FulfilmentMessagePanel data-test='fulfilment-msg-panel' PDP_V2_FLAG={PDP_V2_FLAG}>
            <CollectionTitle collectable={collectable} />
            <CollectionMessage {...collectionMessageProps} />
            <CollectionTrolleyButton {...collectionTrolleyButtonProps} />
          </Styled.FulfilmentMessagePanel>
        )}

        <AlternativeCollectionBox {...alternativeCollectionBoxProps} />
      </Styled.FulfilmentCollectionContainer>
    )
  )
}

export default CollectionBox
